import { render } from "./VistaHistorialCentros.vue?vue&type=template&id=bd368902&scoped=true"
import script from "./VistaHistorialCentros.vue?vue&type=script&lang=js"
export * from "./VistaHistorialCentros.vue?vue&type=script&lang=js"

import "./VistaHistorialCentros.vue?vue&type=style&index=0&id=bd368902&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd368902"]])

export default __exports__